import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({ session, userRole, requiredRole, children }) {
  const [adminAuth, setAdminAuth] = useState(null);
  const [checking, setChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Check for admin token if requiring admin access
    if (requiredRole === 'admin') {
      const adminToken = localStorage.getItem('admin_token');
      const adminUser = localStorage.getItem('admin_user');
      
      console.log('🔐 Checking admin auth:', { 
        hasToken: !!adminToken, 
        hasUser: !!adminUser,
        path: location.pathname 
      });
      
      setAdminAuth(!!adminToken && !!adminUser);
    }
    setChecking(false);
  }, [requiredRole, location.pathname]);

  // Still checking authentication
  if (checking) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  // Admin route - check for admin token
  if (requiredRole === 'admin') {
    if (!adminAuth) {
      console.log('❌ No admin auth - redirecting to /admin/login');
      return <Navigate to="/admin/login" replace />;
    }
    console.log('✅ Admin authenticated - allowing access');
    return children;
  }

  // User routes - check Supabase session
  if (!session) {
    console.log('❌ No session - redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  // Logged in but role not loaded yet
  if (!userRole) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white">Loading user data...</div>
      </div>
    );
  }

  // If user is admin and trying to access user dashboard, redirect to admin
  if (userRole === 'admin' && location.pathname.startsWith('/dashboard')) {
    console.log('✅ Admin user detected - redirecting to admin panel');
    return <Navigate to="/admin/login" replace />;
  }

  // All checks passed - render children
  console.log('✅ Access granted for user route');
  return children;
}

export default ProtectedRoute;